import { initCustomCheckboxes, initCustomRadios } from '../common'
/**
 * Settings page
 */
class Settings {
    constructor(translations) {
        this.texts = translations;
        var that = this;

        // general settings
        $('form[data-settings="profile"]').find('button').click(this.updateGeneralSettings);
        $('form[data-settings="password"]').find('button').click(this.updateGeneralSettings);

        // notifications
        initCustomCheckboxes($('section.notifications'), this.updateEmailNotificationsSettings);

        // privacy
        initCustomRadios($('section.privacy'), this.updatePrivacySettings);

        // delete user
        $('a#delete-user').click(function() {
            var email = $(this).data('email');

            if(email == undefined || email == '' || email.length < 6) {
                alert(that.texts.noValidEmail);
            }
            else {
                if(window.confirm(that.texts.deleteConfirmation)){
                    $.ajax({
                        url: "/profile/send-delete-mail/",
                        dataType: 'json',
                        type: 'post',
                        success: function(data) {
                            if(data && data.status != undefined && data.status) {
                                alert(that.texts.deleteConfirmationSent.replace(/%s/, email));
                            }
                            else {
                                alert(that.texts.deleteConfirmationFailed);
                            }
                        }
                    });
                }
            }

            return false;
        });

        // socials
        $('a.open', 'section.social').click(function() {
            that.toggleSocialMenu($(this));
            return false;
        });

        $('form', 'section.social').each(function() {
            $(this).data('height', $(this).height('auto').outerHeight());
            $(this).height(0);
        });

        initCustomCheckboxes($('section.social form.facebook'), this.updateFacebookSettings);
        initCustomCheckboxes($('section.social form.twitter'), this.updateTwitterSettings);
    }

    updateGeneralSettings(e){
        e.preventDefault();

        var element = $(this);
        var form = element.closest('form');
        var settings = form.data('settings');

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            method: 'post',
            data: form.serialize(),
            success: function(data) {
                if(data.status == true) {
                    if(data.clear) {
                        form.find('input').val('');
                    }

                    element.siblings('div.message').remove();

                    if(data.message.length > 0) {
                        element.before('<div class="' + data.messageClass + '">' + data.message + '</div>');
                    }

                    setTimeout(function() {
                        element.siblings('div.message').remove();
                    }, 3000);

                    $(element).siblings('input[name="old-password"]').show();
                }
                else {
                    if(data.clear) {
                        form.find('input').val('');
                    }

                    element.siblings('div.' + data.messageClass).remove();
                    element.before('<div class="' + data.messageClass + '">' + data.message + '</div>');
                }

                if(data.email != undefined && data.email.length > 0) {
                    $('a#delete-user').data('email', data.email);
                }
            }
        });
    }

    updateEmailNotificationsSettings(setting, value) {
        $.ajax({
            url: "/settings/email-notifications-change/",
            dataType: "json",
            data: {
                setting: setting,
                value: + /^true$/i.test(value)
            },
            success: function(data) {
            }
        });
    }

    updateNotificationsSettings(setting, value) {
        // $.ajax({
        //     url: "/settings/notifications-change",
        //     dataType: "json",
        //     data: {
        //         setting: setting,
        //         value: + /^true$/i.test(value)
        //     },
        //     success: function(data) {
        //     }
        // });
    }

    updatePrivacySettings(setting, value) {
        $.ajax({
            url: "/settings/privacy-change/",
            dataType: "json",
            data: {
                setting: setting,
                value: value
            },
            success: function(data) {
            }
        });
    }

    toggleSocialMenu(button) {
        $('a.open', 'section.social').each(function() {
            if($(this).index() == $(button).index() && !$(this).hasClass('opened')) {
                $(this).addClass('opened');
                $(this).next('form').height($(this).next('form').data('height'));
            }
            else {
                $(this).removeClass('opened');
                $(this).next('form').height(0);
            }
        });
    }

    updateFacebookSettings(setting, value) {
        $.ajax({
             url: "/settings/facebook-change/",
             dataType: "json",
             data: {
                 setting: setting,
                 value: + /^true$/i.test(value)
             },
             success: function(data) {
             }
         });
    }

    updateTwitterSettings(setting, value) {
        $.ajax({
             url: "/settings/twitter-change/",
             dataType: "json",
             data: {
                 setting: setting,
                 value: + /^true$/i.test(value)
             },
             success: function(data) {
             }
         });
    }
}

export { Settings }
